import { render, staticRenderFns } from "./AntdButton.vue?vue&type=template&id=78824fa4&scoped=true"
import script from "./AntdButton.vue?vue&type=script&lang=js"
export * from "./AntdButton.vue?vue&type=script&lang=js"
import style0 from "./AntdButton.vue?vue&type=style&index=0&id=78824fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78824fa4",
  null
  
)

export default component.exports